import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'https://www.api.aslanyazilimm.com'

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
})

// Response interceptor
apiClient.interceptors.response.use(
    response => {
        console.log('API Response:', response.config.url, response.status)
        return response.data || response
    },
    error => {
        console.error('API Error:', error.message)
        if (error.code === 'ERR_NETWORK') {
            throw new Error('API sunucusuna bağlanılamıyor')
        }
        throw new Error(error.message || 'API hatası')
    }
)

export class ApiService {
    
    // Generic request method
    static async makeRequest(endpoint, params = {}) {
        try {
            const response = await apiClient.get(endpoint, { params })
            return response
        } catch (error) {
            console.error('API Request error:', error)
            throw error
        }
    }
    
    static async getHeroSlides() {
        try {
            // Frontend için sadece aktif slide'ları getir
            const response = await apiClient.get('/api/hero-slides.php', {
                params: { active: 'true' }
            })
            return response.data || []
        } catch (error) {
            // console.error('Hero slides error:', error)
            return []
        }
    }

    static async getNews(params = {}) {
        try {
            const response = await apiClient.get('/api/news.php', { params })
            if (response.success && response.data && response.data.news) {
                return response.data.news
            }
            return response.data || []
        } catch (error) {
            // console.error('News error:', error)
            return []
        }
    }

    static async getStatistics() {
        try {
            // console.log('🔄 Making statistics API call...')
            const response = await this.makeRequest('/api/statistics.php')
            // console.log('📊 Statistics API response:', response)
            
            if (response.data && Array.isArray(response.data)) {
                return response.data
            } else if (response.data) {
                return response.data
            }
            
            // console.warn('⚠️ No valid statistics data, using fallback')
            return this.getFallbackStatistics()
        } catch (error) {
            // console.error('❌ Statistics error:', error)
            // console.log('🔄 Using fallback statistics data')
            return this.getFallbackStatistics()
        }
    }

    static getFallbackStatistics() {
        return [
            {
                id: 1,
                value: 15,
                label_tr: 'Yıl Deneyim',
                label_en: 'Years Experience',
                icon: '🏆'
            },
            {
                id: 2,
                value: 500,
                label_tr: 'Tamamlanan Proje',
                label_en: 'Completed Projects',
                icon: '🏠'
            },
            {
                id: 3,
                value: 1200,
                label_tr: 'Mutlu Müşteri',
                label_en: 'Happy Customers',
                icon: '😊'
            },
            {
                id: 4,
                value: 25,
                label_tr: 'MW Kurulu Güç',
                label_en: 'MW Installed Capacity',
                icon: '⚡'
            }
        ]
    }

    static async getInfoCards() {
        try {
            console.log('🔄 Making info cards API call...')
            const response = await this.makeRequest('/api/info-cards.php')
            console.log('🎴 Info Cards API response:', response)
            
            if (response.data && Array.isArray(response.data)) {
                console.log('✅ Info cards array found:', response.data.length, 'cards')
                console.log('📋 Info cards data details:', JSON.stringify(response.data, null, 2))
                return response.data
            } else if (response.data) {
                console.log('✅ Info cards data found (non-array):', response.data)
                return response.data
            }
            
            console.warn('⚠️ No valid info cards data, using fallback')
            return this.getFallbackInfoCards()
        } catch (error) {
            console.error('❌ Info Cards error:', error)
            console.log('🔄 Using fallback info cards data')
            return this.getFallbackInfoCards()
        }
    }

    static async getAboutFeatures() {
        try {
            console.log('🔄 Making about features API call...')
            // Return empty array for now - implement if needed
            return []
        } catch (error) {
            console.error('❌ About Features error:', error)
            return []
        }
    }

    static getFallbackInfoCards() {
        return [
            {
                id: 1,
                card_type: 'yellow-card',
                title_tr: 'Güneş Enerjisi Sistemleri',
                title_en: 'Solar Energy Systems',
                description_tr: 'Ev ve işyerleriniz için yüksek verimli güneş paneli sistemleri. Temiz enerji ile hem çevreyi koruyun hem de elektrik faturalarınızı azaltın.',
                description_en: 'High-efficiency solar panel systems for homes and businesses. Protect the environment and reduce your electricity bills with clean energy.',
                button_text_tr: 'Keşfet',
                button_text_en: 'Explore',
                button_action: 'contact',
                background_image: null,
                icon: null,
                background_color: null,
                text_color: null
            },
            {
                id: 2,
                card_type: 'black-card',
                title_tr: 'Enerji Depolama',
                title_en: 'Energy Storage',
                description_tr: 'Gelişmiş batarya teknolojileri ile ürettiğiniz enerjiyi depolayın. Kesintisiz güç sağlayın ve enerji bağımsızlığınızı artırın.',
                description_en: 'Store your generated energy with advanced battery technologies. Provide uninterrupted power and increase your energy independence.',
                button_text_tr: 'Detaylar',
                button_text_en: 'Details',
                button_action: 'contact',
                background_image: null,
                icon: null,
                background_color: null,
                text_color: null
            },
            {
                id: 3,
                card_type: 'image-card',
                title_tr: 'Uzman Danışmanlık',
                title_en: 'Expert Consulting',
                description_tr: 'Alanında uzman ekibimizle size özel enerji çözümleri geliştiriyoruz. Proje planlamadan kuruluma kadar her aşamada yanınızdayız.',
                description_en: 'We develop customized energy solutions with our expert team. We are with you at every stage from project planning to installation.',
                button_text_tr: 'İletişim',
                button_text_en: 'Contact',
                button_action: 'contact',
                background_image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
                icon: null,
                background_color: null,
                text_color: null
            }
        ]
    }

    static async getServices() {
        try {
            const response = await apiClient.get('/api/services.php')
            if (response.success && response.data) {
                return response.data
            }
            return response.data || []
        } catch (error) {
            // console.error('Services error:', error)
            return []
        }
    }

    static async getProjects(params = {}) {
        try {
            // console.log('🔄 Making projects API call...', params)
            const response = await this.makeRequest('/api/projects.php', params)
            // console.log('📦 Raw projects response:', response)
            
            // Response interceptor zaten response.data döndürüyor
            if (response && response.success && response.data) {
                // console.log('✅ Projects data found:', response.data)
                return {
                    data: response.data,
                    total: response.total || response.data.length,
                    page: response.page || params.page || 1,
                    totalPages: response.totalPages || Math.ceil((response.total || response.data.length) / (params.limit || 20))
                }
            } else if (response && Array.isArray(response)) {
                // console.log('✅ Projects array found:', response)
                // Array response için pagination simulate et
                const limit = params.limit || 20
                const page = params.page || 1
                const startIndex = (page - 1) * limit
                const endIndex = startIndex + limit
                
                return {
                    data: response.slice(startIndex, endIndex),
                    total: response.length,
                    page: page,
                    totalPages: Math.ceil(response.length / limit)
                }
            } else if (response && response.data && Array.isArray(response.data)) {
                // console.log('✅ Projects data array found:', response.data)
                const limit = params.limit || 20
                const page = params.page || 1
                const startIndex = (page - 1) * limit
                const endIndex = startIndex + limit
                
                return {
                    data: response.data.slice(startIndex, endIndex),
                    total: response.data.length,
                    page: page,
                    totalPages: Math.ceil(response.data.length / limit)
                }
            }
            
            // console.warn('⚠️ No valid projects data found')
            return { data: [], total: 0, page: 1, totalPages: 0 }
        } catch (error) {
            // console.error('❌ Projeler alınırken hata:', error)
            return { data: [], total: 0, page: 1, totalPages: 0 }
        }
    }

    static async getProjectById(id) {
        try {
            // console.log('🔄 Making project detail API call for ID:', id)
            const response = await this.makeRequest(`/api/projects.php?id=${id}`)
            // console.log('📦 Raw project detail response:', response)
            
            if (response && response.success && response.data) {
                // console.log('✅ Projects data found:', response.data)
                return response.data
            } else if (response && response.data) {
                                // console.log('✅ Project detail found:', response.data)
                return response.data
            }
            
            console.warn('⚠️ No valid project detail found')
            return null
        } catch (error) {
            console.error('❌ Proje detayı alınırken hata:', error)
            return null
        }
    }

    static async getMissionVisionCards() {
        try {
            const response = await apiClient.get('/api/mission-vision.php')
            if (response.success && response.data) {
                return response.data
            }
            return this.getFallbackMissionVision()
        } catch (error) {
            console.error('Mission vision error:', error)
            return this.getFallbackMissionVision()
        }
    }

    static getFallbackMissionVision() {
        return [
            {
                id: 1,
                title_tr: 'Misyonumuz',
                title_en: 'Our Mission',
                description_tr: 'Yenilenebilir enerji çözümleriyle sürdürülebilir bir gelecek inşa etmek',
                description_en: 'Building a sustainable future with renewable energy solutions',
                icon_svg: ''
            },
            {
                id: 2,
                title_tr: 'Vizyonumuz',
                title_en: 'Our Vision',
                description_tr: 'Türkiye\'nin önde gelen yenilenebilir enerji şirketi olmak',
                description_en: 'To become Turkey\'s leading renewable energy company',
                icon_svg: ''
            }
        ]
    }

    static async getReferences(params = {}) {
        try {
            const response = await apiClient.get('/api/references.php', { params })
            if (response.success && response.data) {
                return response.data
            }
            return this.getFallbackReferences()
        } catch (error) {
            console.error('References error:', error)
            return this.getFallbackReferences()
        }
    }

    static getFallbackReferences() {
        return [
            { id: 1, company_name: 'Schneider Electric', logo_url: 'text-logo' },
            { id: 2, company_name: 'Siemens Türkiye', logo_url: 'text-logo' },
            { id: 3, company_name: 'TEİAŞ', logo_url: 'text-logo' }
        ]
    }

    static async getMachinery(params = {}) {
        try {
            const response = await apiClient.get('/api/machinery.php', { params })
            
            // API response interceptor already returns response.data, so check different structures
            if (response && response.success && response.data && Array.isArray(response.data)) {
                return response.data
            } else if (response && Array.isArray(response.data)) {
                return response.data
            } else if (response && Array.isArray(response)) {
                return response
            } else if (response && response.success && response.data) {
                return Array.isArray(response.data) ? response.data : [response.data]
            }
            
            console.warn('Unexpected machinery response format, using fallback')
            return this.getFallbackMachinery()
        } catch (error) {
            console.error('Machinery API error:', error)
            return this.getFallbackMachinery()
        }
    }

    static async getMachineryById(id) {
        try {
            console.log('🔄 Making machinery detail API call for ID:', id)
            const response = await apiClient.get(`/api/machinery.php?id=${id}`)
            console.log('📦 Raw machinery detail response:', response)
            
            if (response && response.success && response.data) {
                console.log('✅ Machinery detail found:', response.data)
                return response.data
            } else if (response && response.data) {
                console.log('✅ Machinery detail data found:', response.data)
                return response.data
            }
            
            console.warn('⚠️ No valid machinery detail found')
            return this.getFallbackMachinery().find(m => m.id == id) || this.getFallbackMachinery()[0]
        } catch (error) {
            console.error('❌ Makine detayı alınırken hata:', error)
            return this.getFallbackMachinery().find(m => m.id == id) || this.getFallbackMachinery()[0]
        }
    }

    static getFallbackMachinery() {
        return [
            {
                id: 1,
                brand: 'EPIROC',
                name_tr: 'FlexiROC T40',
                name_en: 'FlexiROC T40',
                category_tr: 'Yüzey Delme Makinası',
                category_en: 'Surface Drilling Machine',
                description_tr: 'Kompakt ve güçlü yüzey delme makinası',
                description_en: 'Compact and powerful surface drilling machine',
                image_url: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
                drilling_diameter: '76-127 mm',
                drilling_depth: '25 m',
                motor_power: '129 kW',
                weight: '18,500 kg',
                specifications: {
                    'drilling_diameter': '76-127 mm',
                    'drilling_depth': '25 m',
                    'motor_power': '129 kW',
                    'weight': '18,500 kg'
                },
                features_tr: ['Otomatik rod değişimi', 'GPS navigasyon sistemi', 'Toz bastırma sistemi'],
                features_en: ['Automatic rod handling', 'GPS navigation system', 'Dust suppression system'],
                features: ['Otomatik rod değişimi', 'GPS navigasyon sistemi', 'Toz bastırma sistemi']
            }
        ]
    }

    static async sendContactMessage(messageData) {
        try {
            const response = await apiClient.post('/api/contact.php', messageData)
            return response
        } catch (error) {
            console.error('Contact error:', error)
            throw error
        }
    }

    // Image URL helper - CORS ve görsel sorunlarını çözer
    static getImageUrl(imageUrl, fallbackUrl = 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80') {
        // Null, undefined veya boş string kontrolü
        if (!imageUrl || imageUrl.trim() === '' || imageUrl === 'null' || imageUrl === 'undefined') {
            console.warn('🚫 Invalid image URL provided:', imageUrl, '→ Using fallback');
            return fallbackUrl;
        }
        
        // Eğer zaten tam URL ise ve geçerli protocol'e sahipse direkt döndür
        if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
            return imageUrl;
        }
        
        // Göreli path ise tam URL'ye çevir
        const baseUrl = 'https://egesa.com.tr';
        const cleanPath = imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`;
        const fullUrl = `${baseUrl}${cleanPath}`;
        
        console.log('🔗 Image URL processed:', imageUrl, '→', fullUrl);
        return fullUrl;
    }
}

export default ApiService
